import { render, staticRenderFns } from "./ChartSideBar.vue?vue&type=template&id=022eeff0&scoped=true"
import script from "./ChartSideBar.vue?vue&type=script&lang=js"
export * from "./ChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./ChartSideBar.vue?vue&type=style&index=0&id=022eeff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022eeff0",
  null
  
)

export default component.exports